export const formateName = (fullName, format = 'F I O') => {
	if (!fullName) return null;

	const cleanName = fullName.replace(/\s+/g, ' ').trim();
	const parts = cleanName.split(' ');

	return format
		.replace(/\bF\b/, parts[0] || '')
		.replace(/\bI\b/, parts[1] || '')
		.replace(/\bO\b/, parts[2] || '');
};
